<template>
    <div>
    <!--
    <div class="history" v-if="elementStepper">
        <md-steppers ref="step" md-vertical>
        <md-step
            v-for="(value, index) in traceName" 
            v-bind:key="index"
            :md-label="value"
            :md-editable="false"
            :md-done="true"/>
        </md-steppers> 
    </div>
    -->
    <div class="md-layout">
        <div class="logo" :class="{ 'bordershow': !borderShow }">
            <img src="@/assets/faro2.png" width="179"/>
        </div>  
    </div>
    <div class="md-layout int">
        <div class="md-layout-item">
            <div v-for="(value, index) in history" v-bind:key="index" :id="value.id">
                <component v-if="value.show == true" 
                :title="title" :is="index" 
                @setDone="setDoneRoot" 
                @setBack="setBackRoot" 
                @setSaveForm="setSaveFormRoot"
                @downloadFile="downloadFile"
                :complete="complete"
                :pais="pais"
                :data="data"
                :isDisabled="isDisabled"/>          
            </div>
        
        </div>
    </div>  
</div>    
</template>

<script>
import {
    Item000,
    Item1,
    Item2,
    Item3,
    Item4,
    Item5,
    Item6,
    Item7,
    Item8,
    Item9,
    Item10,
    Item11,
    Item111,
    Item112,
    Item113,
    Item12,
    Item13,
    Item14,
    Item15,
    Item16,
    Item17,
    Item18,
    Item19,
    Item20,
    Item21,
    Item30,
} from "./index";
import eventBus from '../bus'
import pais from '../json/pais.json'

export default {
    name:"HomeParticipe",
    data: () => ({  
      active: '000',
      preview: null,
      enviar:false,
      history:{},
      traceName:[],
      title:null,  
      complete:0,
      pais:[],
      borderShow: true,
      lastScrollPosition: 0,
      isDisabled: false   
    }),
    props: {
        data: Object,
    },     
    async mounted(){
        await this.Init()
    },
    beforeDestroy () {
        window.removeEventListener('scroll', this.onScroll)
    },    
    methods:{
        async Init(){
            this.title = this.data.name == "Participe" ? "Titular" : "Mancomuno";
            this.history = this.$store.state.historyParticipe
            this.traceName = this.$store.state.traceName
            this.preview = this.active
            this.$store.dispatch("tipo", {tipo:"P", active: this.active});
            eventBus.$emit('isLoading', true);
            var that = this
            that.pais = pais;
            window.addEventListener('scroll', this.onScroll)
            var req = { token: this.$route.params.id.toString(), router: this.$route.name}    
            await this.$store.dispatch("loadFormulario", this.$route.params.id.toString())
            .then((response)=>{
                that.$store.dispatch("loadFondos", "P")
                if(!Array.isArray(response)){
                    that.active = response.active
                    that.complete = response.complete
                }
                eventBus.$emit('isLoading', false);
                //carga de la alta rapida en los formularios
                that.$store.dispatch("loadDataTitular", req)
                this.activeComponent()
            })
            .catch(()=>{
                eventBus.$emit('isLoading', false);
                this.$router.push({name:"Error"})
                this.activeComponent()
            });   

        },
        scrollTop(){
            window.scrollTo(0, 0);            
        },
        onScroll () {
            const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop
            if (currentScrollPosition < 0) {
                return
            }
            // Stop executing this function if the difference between
            // current scroll position and last scroll position is less than some offset
            if (Math.abs(currentScrollPosition - this.lastScrollPosition) < 60) {
                return
            }
            this.borderShow = currentScrollPosition < this.lastScrollPosition
            this.lastScrollPosition = currentScrollPosition
        },        
        setDoneRoot(p){
            this.setDoneForm(p)
            this.activeComponent()
        },        
        setDoneForm(p){
            this.preview = p.id;
            
            this.history["item"+p.id].enviado = true

            if (p.index) {
                this.active = p.index
            }
            this.$store.dispatch("tipo", {tipo:"P", active: this.active});

            this.scrollTop()
        },        
        setBackRoot(p){
            var that = this
            eventBus.$emit('isLoading', true);
            eventBus.$emit('buttonDisabled', true);
            var form = p.id.toLowerCase();
            this.$store.dispatch("resetitem", {
                id: form, 
                //no quieren que resetee
                //form: this.$store.state.reset.item[form], 
                form: this.$store.state.item[form], 
                complete: 0, 
                ide: this.$route.params.id.toString() 
            })
            .then(() =>{

                var array = that.$store.state.trace;
                const lastItem = array[array.length - 1]
                that.preview = lastItem

                that.active = that.history["item"+this.preview].id;

                that.$store.dispatch("tipo", {tipo:"P", active: that.active});
                
                that.history[form].enviado = false
                that.history[form].show = false;
                that.$store.dispatch("trace")

                that.activeComponent()
                that.scrollTop()
                eventBus.$emit('isLoading', false);
            })
            .catch(()=>{
                eventBus.$emit('isLoading', false);
                that.$router.push({name:"Error"})
            });


        },             
        setSaveFormRoot(p){
            eventBus.$emit('isLoading', true);
            eventBus.$emit('buttonDisabled', true);
            this.setDoneForm(p)
            var that = this
            return this.$store.dispatch("item", {
                form:p, 
                ide: this.$route.params.id.toString(), 
                complete: 0
            })            
            .then(() =>{
                eventBus.$emit('isLoading', false);
                that.activeComponent()
            })
            .catch(()=>{
                eventBus.$emit('isLoading', false);
                that.$router.push({name:"Error"})
            })
        },   
        activeComponent(){
            this.inactiveComponent()
            this.history["item"+this.preview].show = false;
            this.history["item"+this.active].show = true;
            //this.traceName = this.$store.state.traceName; 
        },
        inactiveComponent(){
            this.$store.dispatch("hideAllComponent");
        },
        downloadFile(item){
            return item;
        }

    },
    computed:{
        elementStepper: function(){
        if(this.traceName.length == 0){
            return false
        }
        return true
        }
    },
    async beforeRouteUpdate(to, from, next) {
        await window.location.reload()
        await next()
    },
    components:{    
        Item000,
        Item1,
        Item2,
        Item3,
        Item4,
        Item5,
        Item6,
        Item7,
        Item8,
        Item9,
        Item10,
        Item11,
        Item111,
        Item112,
        Item113,
        Item12,
        Item13,
        Item14,
        Item15,
        Item16,
        Item17,
        Item18,
        Item19,
        Item20,
        Item21,
        Item30,
    }
}
</script>

<style>

</style>